<script lang="ts">
  import type { Snippet } from "svelte";

  let {
    icon = "trip",
    title,
    description,
    children,
  }: {
    icon?: string;
    title: string;
    description: string;
    children?: Snippet;
  } = $props();

  const svgIcons: Record<string, string> = {
    trip: `<path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />`,
    expense: `<path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />`,
    schedule: `<path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />`,
  };

  const isSvgKey = $derived(icon in svgIcons);
</script>

<div class="text-center py-16 empty-state">
  {#if isSvgKey}
    <svg
      class="mx-auto h-16 w-16 empty-state__icon"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      {@html svgIcons[icon]}
    </svg>
  {:else}
    <div class="mx-auto flex h-16 w-16 items-center justify-center text-5xl" aria-hidden="true">{icon}</div>
  {/if}
  <h3 class="mt-4 text-lg font-medium empty-state__title">{title}</h3>
  <p class="mt-2 empty-state__description">{description}</p>
  <div class="mt-6">
    {@render children?.()}
  </div>
</div>

<style>
  .empty-state__icon {
    color: var(--text-muted);
  }

  .empty-state__title {
    color: var(--text-primary);
  }

  .empty-state__description {
    color: var(--text-secondary);
  }
</style>
